TradeNews2.vue<template>
	<!-- star -->

	<div class="youjiaopage_wrap">
		<nav2></nav2>
		<banner2 :bannerH="h1" :bannerP="p1" :bannerImg="Img1"></banner2>
		<!-- 面包屑 -->
<!--		<div class="Crumbs">-->
<!--			<div>当前位置：首页><span>金融</span></div>-->
<!--		</div>-->
		<!--  -->
		<div class="NewsDetails">
			<div class="NewsDetails_cont">
				<div class="NewsDetails_cont_title">
					<h1>2024产学研融通创新活动：AI应用落地是重点</h1>
					<div class="NewsDetails_cont_title_span">
						<img src="../../assets/img/newsDetail/矩形.png" alt="" /><span
							>发布时间：2024-10-27&ensp;&ensp;
						</span>
<!--						<img src="../../assets/img/newsDetail/矩形(1).png" alt="" /><span-->
<!--							>浏览次数：288-->
<!--						</span>-->
					</div>
				</div>
				<div class="NewsDetails_cont_text">
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;探索AI边界，重构数字场景，9月27日，2024产学研融通创新活动由中国科学技术协会企业创新服务中心、北京经济技术开发区管理委员会主办，中关村产业技术联盟联合会、中国通信工业协会数据中心委员会（CIDC）、北京通明湖信息城发展有限公司、京东云承办，数字开物、中国 IDC 圈、北京首科集团有限公司协办。</p>

          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;活动主题为“探索AI边界 重构数字场景”，邀请到来自全国各地的行业精英、专家学者和企业代表们共襄盛宴，分享其最新创新案例与优秀成果，见证了当前AI及大模型在产业中的最新应用进展，共同探讨行业的未来发展之路。</p>
          <div class="NewsDetails_cont_img">
            <img
                src="../../assets/img/news/图片1.png"
                alt=""
            />
          </div>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;谭建荣院士现场讲解了生成式人工智能与数字化转型的关键问题。“我们现在要想高质量发展、创新发展人工智能，需要把人工智能技术跟制造企业的数字化转型有机融合起来。”</p>

          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;AI的发展速度远超过我们的想象，如何通过产学研各界的深度合作，促进AI大模型加速落地应用，发挥AI技术的普惠性，深度赋能千行百业的关键是数字化转型。</p>

          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;“在数据还是一盘散沙时，我们要把数据的联系找出来，要把数据隐含的规律、隐含的价值找出来，找出来的东西就是知识。定量的知识就是模型。”谭院士还强调到，大数据、大模型需要大算力来计算，所以现在算力成了一个国家、一个地区的核心竞争力，“大模型一出来，我国就涌现了200多个大模型，现在是百模大战，具体哪个模型好用，不同领域有不同的模型。”</p>

          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;针对大模型人工智能的发展，谭院士指出两种模式：一是从小模型做起。先构建一个包括各个行业、企业阶层的小模型，把内部机构模型搞清楚。二是做垂直领域的大模型。 只有垂直才会有深度，避免泛泛的通用模型。</p>

          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;针对如何推进大模型落地问题，李论主任认为，模型本身的智能化水平以及计算量的提升十分重要。“在现有系统下如何提升模型的智能水平，能够让模型和它的典型场景深入契合是关键，比如说在行业落地的过程中训练的数据、微调的数据至关重要，它是在有效的资源下提升模型和行业结合的关键。第二就是做算法模型一系列的改造。”李主任还强调“针对不同体量的企业开闭源怎么结合，以及大模型小模型怎么互通也是大家关注的重点，突破模态瓶颈，增加视频、音频的多模态通用模型是后续突破的重点。当前基础模型发展收敛，行业模型落地成为新起点，未来模型发展仍遵循规模定律，关键在于解决“最后一公里”和工程化问题，释放技术红利。”</p>

          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;京东云着眼大模型如何在产业跑起来。袁黎江总监介绍了京东云针对“最后一公里”做出来的一系列技术的努力。提到京东云一直在探索大模型与行业的深度融合，坚信大模型要真正在产业中用起来，才能活起来。目前，越来越多的大模型应用，正在京东供应链上生长，在京东内部超百个场景全面铺开。最后，袁总监总结到“京东一直秉持大模型要服务于产业落地，所以大模型是来自于产业，理解产业，服务产业，融入产业，真正体现出大模型的价值。”</p>
          <div class="NewsDetails_cont_img">
            <img
                src="../../assets/img/news/图片2.png"
                alt=""
            />
          </div>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;会议期间还遴选出了20个优秀的案例，优秀案例代表徐冰玉指出“基于中医个性化、多样化、千人千面化，对于中医在传承领域高度依赖于师徒关系的本质，我们相信AI正好补足这方面的痛点，能够非常好地助力AI在中医领域的发展，它的前景是非常好的。”AI在中医药当中主要可以在五大应用场景进行应用：辅助诊断、健康管理和养生、医疗资源和管理的分配、中药研发、中医教育与培训。</p>

          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为了促进AI大模型在各领域的加速落地应用，在活动特设的“融通对接”圆桌对话环节，邀请了不同领域的代表基于“AI大模型应用场景真正爆发离我们还有多远？”话题进行了深入的探讨。</p>
          <div class="NewsDetails_cont_img">
            <img
                src="../../assets/img/news/图片3.png"
                alt=""
            />
          </div>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;北京弘易信泰科技发展有限公司是一家创新型的软件与信息服务公司，应用大数据、人工智能、云计算等技术，提供定制化数据治理解决方案，助力客户信息化业务。受邀参会，通过探索AI边界，优化人工智能信息化解决方案，为更好地服务客户打好基础。</p>


        </div>

<!--				<div class="NewsDetails_cont_btm">-->
<!--					<div>相关新闻</div>-->
<!--					<p>更多 ></p>-->
<!--				</div>-->
<!--				<div class="NewsDetails_cont_btm2">-->
<!--					<div class="NewsDetails_cont_btm2_1">-->
<!--						<div>发展数字经济 共享包容增长 为经济发展插上“数字翅膀”</div>-->
<!--						<p>2021-05-30</p>-->
<!--						<p>-->
<!--							中国心理学会法律心理学分会副会长、中国人民公安大学教授李玫瑾，同时也担任中国预防青少年犯罪研究会的副会长...-->
<!--						</p>-->
<!--					</div>-->
<!--					<div class="NewsDetails_cont_btm2_1" style="background: #f8f8f8">-->
<!--						<div>发展数字经济 共享包容增长 为经济发展插上“数字翅膀”</div>-->
<!--						<p>2021-05-30</p>-->
<!--						<p>-->
<!--							中国心理学会法律心理学分会副会长、中国人民公安大学教授李玫瑾，同时也担任中国预防青少年犯罪研究会的副会长...-->
<!--						</p>-->
<!--					</div>-->
<!--				</div>-->
			</div>
		</div>

		<footer2></footer2>

		<!-- end -->
	</div>
</template>

<script>
import footer2 from "../../components/footer.vue";
import banner2 from "../../components/banner.vue";
import nav2 from "../../components/nav.vue";
export default {
	name: "news2",
	components: {
		footer2,
		nav2,
		banner2,
	},
	// data() {
	// 	return {
	// 		h1: "企业新闻",
	// 		Img1: require("../../assets/img/keji/矿山banner1.png"),
  //
	// 		p1: "更多最新精彩资讯，感受企业魅力",
	// 	};
	// },
	methods: {},
};
</script>
<style scoped>
@charset "utf-8";
/*=========================Reset_start==========================*/
body,
h1,
h2,
h3,
h4,
h5,
h6,
div,
p,
dl,
dt,
dd,
ol,
ul,
li,
form,
table,
th,
td,
a,
img,
span,
strong,
var,
em,
input,
textarea,
select,
option {
	margin: 0;
	padding: 0;
}
/*去内外边距*/
html,
body {
  //font-family: "微软雅黑", "宋体", Arail, Tabhoma;
  font-family: AlibabaPuHuiTi-3-55-Regular;
  text-align: left;
}
/*字体 文本居左*/
ul {
  list-style: none;
}
/*去ul li 小点*/
img {
  border: 0 none;
}
/*img IE6 兼容问题*/
input,
select,
textarea {
  outline: 0;
}
/*去除点击蓝框*/
textarea {
  resize: none;
  overflow: auto;
}
/*锁定多行文本框大小 与文字超出出现滚动条*/
table {
  border-collapse: collapse;
  border-spacing: 0;
}
/*表格边框合并 边框间距0*/
th,
strong,
var,
em {
  font-weight: normal;
  font-style: normal;
}
/*特殊文字粗细 样式显示正常*/
a {
  text-decoration: none;
}
/*a标签去下划线*/
.clearfix:after {
  clear: both;
  content: "";
  display: block;
  height: 0;
}
/*清浮动*/
a {
  color: #000000;
}
/*==========================Reset_End===========================*/

.youjiaopage_wrap {
  width: 100vw;
  margin: 0 auto;
  height: 1000px;
}
/* 面包屑 */
.Crumbs {
  width: 1200px;
  height: 46px;
  margin: 0 auto;
}
.Crumbs {
  font-size: 12px;
  //font-family: PingFangSC-Regular, PingFang SC;
  font-family: AlibabaPuHuiTi-3-55-Regular;
  font-weight: 400;
  color: #999999;
  line-height: 17px;
}
.Crumbs div {
  line-height: 46px;
}
.Crumbs span {
  color: #000000;
}
/* 新闻详情 */
.NewsDetails_cont {
  width: 1200px;
  margin: 0 auto;
  margin-top: 120px ;
  border-top: 1px solid #eaeaea;
}
.NewsDetails_cont_title > h1 {
  font-size: 28px;
  font-family: AlibabaPuHuiTi-3-55-Regular;
  font-weight: 800;
  color: #2b2b2b;
  line-height: 33px;
  margin-top: 78px;
  text-align: center;
}
.NewsDetails_cont_title img {
  vertical-align: middle;
}
.NewsDetails_cont_title_span {
  text-align: center;
  font-size: 14px;
  font-family: AlibabaPuHuiTi-3-55-Regular;
  //font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #a3a3a3;
  line-height: 30px;
  margin-top: 20px;
}
.NewsDetails_cont_text {
  //margin-top: 40px;
  //border-top: 1px solid #eaeaea;
  font-family: AlibabaPuHuiTi-3-55-Regular;
}
.NewsDetails_cont_text p {
  line-height: 28px;
  width: 1000px;
  margin: 40px 100px;
  font-size: 16px;
  font-weight: lighter;
}
.NewsDetails_cont_text div {
  line-height: 24px;
  margin-left: 90px;
  font-size: 24px;
  font-weight: bold;
}
.NewsDetails_cont_img {
  width: 1000px;
  text-align: center;
  margin-bottom: 40px;
}
.NewsDetails_cont_footer {
  padding: 0 40px;

  line-height: 68px;
  width: 1120px;
  height: 68px;
  background: #f8f8f8;
  display: flex;
  justify-content: space-between;
}
.NewsDetails_cont_btm {
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
.NewsDetails_cont_btm div {
  font-size: 24px;
  font-family: AlibabaPuHuiTi-3-55-Regular;
  font-weight: 400;
  color: #222222;
  line-height: 33px;
}
.NewsDetails_cont_btm p {
  font-size: 14px;
  font-family: AlibabaPuHuiTi-3-55-Regular;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
}
.NewsDetails_cont_btm2 {
  display: flex;
  justify-content: space-between;
}
.NewsDetails_cont_btm2_1 {
  margin: 32px 0;
  padding: 31px 61px 31px 20px;
  width: 507px;
  height: 123px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.11);
}
.NewsDetails_cont_btm2_1 div {
  font-size: 18px;
  font-family: AlibabaPuHuiTi-3-55-Regular;
  font-weight: 500;
  color: #444444;
  line-height: 25px;
}
.NewsDetails_cont_btm2_1 p {
  margin-top: 10px;
  font-size: 14px;
  font-family: AlibabaPuHuiTi-3-55-Regular;
  font-weight: 400;
  color: #666666;
  line-height: 28px;
}
</style>
